import { render, staticRenderFns } from "./ModalAlteracoes.vue?vue&type=template&id=e4a51a82"
import script from "./ModalAlteracoes.vue?vue&type=script&lang=ts"
export * from "./ModalAlteracoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports